export default "__VITE_ASSET__b86273f7__"